import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NbDialogRef, NbDialogService } from "@nebular/theme";
import * as _ from "lodash";
import * as moment from "moment";
import { LocalDataSource } from "ng2-smart-table";
import { Subject } from "rxjs";
import { map, takeUntil } from "rxjs/operators";
import { convertTimestamp } from "../../@core/utils/convertTimestamps.service";
import { Receipt } from "../../models/receipt.model";
import Shop from "../../models/shop.model";

import { ReceiptService } from "../../services/receipt.service";
import { DialogViewReceiptComponent } from "../dialog-view-receipt/dialog-view-receipt.component";

@Component({
  selector: "ngx-dialog-report-receipts",
  templateUrl: "dialog-report-receipts.component.html",
  styleUrls: ["dialog-report-receipts.component.scss"],
})
export class DialogReportReceiptsComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  @Input() shopId?: string;
  @Input() shop: Shop = new Shop();

  @Input() uid?: string;

  @Input() receipts?: Receipt[] = [];

  loading = false;
  strSearch = "";

  periodType = "day";
  periodDate: Date = new Date();
  fromDate: Date = new Date();
  toDate: Date = new Date();
  totalAmount = 0;
  cancelAmount = 0;
  receiptSubs: any;
  source: LocalDataSource = new LocalDataSource();

  constructor(
    protected ref: NbDialogRef<DialogReportReceiptsComponent>,
    private receiptService: ReceiptService,
    private dialogService: NbDialogService
  ) {}

  ngOnInit() {
    this.fromDate = moment().startOf("day").toDate();
    this.toDate = moment().endOf("day").toDate();
    if (!this.receipts || this.receipts.length === 0) {
      this.getReceipts();
    } else {
      this.summaryReceipt();
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  close() {
    this.ref.close();
  }

  viewDetail(item: Receipt) {
    this.dialogService
      .open(DialogViewReceiptComponent, {
        context: {
          shopId: this.shopId,
          receipt: item,
          shop: this.shop,
        },
      })
      .onClose.subscribe((value) => {
        if (value) {
          _.remove(this.receipts, (e) => {
            return e.id == value;
          });
          this.summaryReceipt();
        }
      });
  }

  selectTime(value) {
    console.log("selectTime:", value);
    if (value) {
      this.periodDate = value.periodDate;
      this.fromDate = value.fromDate;
      this.toDate = value.toDate;
      this.periodType = value.type;
      this.getReceipts();
    }
  }

  //functions
  private getReceipts() {
    this.loading = true;
    if (this.receiptSubs) this.receiptSubs.unsubscribe();

    this.receiptSubs = this.receiptService
      .getReceiptsByUser(this.shopId, this.uid, this.fromDate, this.toDate)
      .snapshotChanges(["added", "removed"])
      .pipe(
        map((changes) =>
          changes.map((c) => ({
            id: c.payload.doc.id,
            ...c.payload.doc.data(),
            issueDate: convertTimestamp(c.payload.doc.data().issueDate),
          }))
        ),
        takeUntil(this.destroy$)
      )
      .subscribe(
        (data) => {
          this.receipts = data;
          this.summaryReceipt();
          console.log("getReceipts:", this.receipts);

          this.loading = false;
        },
        (err) => {
          this.receipts = [];
          this.summaryReceipt();
          this.loading = false;
          console.log("getReceipts/err:", err);
        }
      );
  }

  private summaryReceipt() {
    this.totalAmount = 0;
    this.cancelAmount = 0;
    _.forEach(this.receipts, (item) => {
      if (item.isCancel) {
        this.cancelAmount += item.totalAmount;
      } else {
        this.totalAmount += item.totalAmount;
      }
      item.cashierName = item.author.displayName
        ? item.author.displayName
        : item.author.email;
    });
    this.source.load(this.receipts);
  }
}
